// this file has been generated by scripts/generate-error-selectors.ts

import type { Hex } from 'viem'

export const errorSelectors: Record<Hex, string> = {
  '0x0a47c4c6': 'InvalidSettlementId',
  '0x0dc149f0': 'AlreadyInitialized',
  '0x0e9be31c': 'CannotSelfExecute',
  '0x0fbdec0a': 'InvalidEndpointCall',
  '0x1ab7da6b': 'DeadlineExpired',
  '0x1c26714c': 'InsufficientGas',
  '0x1e4fbdf7': 'OwnableInvalidOwner',
  '0x2aa2ed72': 'ExceedsCapacity',
  '0x3c10b94e': 'FnSelectorNotRecognized',
  '0x3d7bbe23': 'InvalidL0SettlerSignature',
  '0x4e23d035': 'IndexOutOfBounds',
  '0x4f0c028c': 'SimulationPassed',
  '0x5ee7e5b1': 'NoSpendPermissions',
  '0x5f3b6d93': 'InvalidWithdrawalSignature',
  '0x6ac5b32f': 'PreCallVerificationError',
  '0x6c9d47e8': 'CallError',
  '0x6c875b4d': 'UnsupportedAccountImplementation',
  '0x6f5e8818': 'NoHandoverRequest',
  '0x7b43b439': 'InspectionFailed',
  '0x7f181275': 'UnsupportedExecutionMode',
  '0x8f56f149': 'PaymasterNonceError',
  '0x9f03a026': 'UnauthorizedCallContext',
  '0x9f704120': 'NotEnoughNative',
  '0x08b320b4': 'OnlyGasWallet',
  '0x12ee5c93': 'NewSequenceMustBeLarger',
  '0x82b42900': 'Unauthorized',
  '0x86e6cce4': 'KeyTypeCannotBeSuperAdmin',
  '0x91ac5e4f': 'OnlyEndpoint',
  '0x95bd7546': 'NewImplementationIsZero',
  '0x118cdaa7': 'OwnableUnauthorizedAccount',
  '0x234e352e': 'SimulateExecuteFailed',
  '0x408b2234': 'IntentExpired',
  '0x871d302a': 'OpDataError',
  '0x2228d5db': 'PreCallError',
  '0x5274afe7': 'SafeERC20FailedOperation',
  '0x7448fbae': 'NewOwnerIsZeroAddress',
  '0x9054c912': 'ExceededSpendLimit',
  '0x81255f6d': 'InvalidKeyHash',
  '0x756688fe': 'InvalidNonce',
  '0x3995943b': 'BatchOfBatchesDecodingError',
  '0x5207031d': 'StateOverrideError',
  '0x5373352a': 'LzTokenUnavailable',
  '0x5605515a': 'DigestUsed',
  '0x04420815': 'SuperAdminCanExecuteEverything',
  '0x87075105': 'KeyHashIsZero',
  '0xa2d0fee8': 'InvalidPublicKey',
  '0xa458261b': 'InsufficientFee',
  '0xaabd5a09': 'InvalidThreshold',
  '0xab143c06': 'Reentrancy',
  '0xabab8fc9': 'PaymentError',
  '0xad4db224': 'VerifiedCallError',
  '0xae4575cd': 'OwnerNotFound',
  '0xb5863604': 'InvalidDelegate',
  '0xc4c3834b': 'InvalidEscrow',
  '0xc7c51965': 'ConfigAlreadySet',
  '0xc26bebcc': 'OnlyPeer',
  '0xd7cc6652': 'SettlementInvalid',
  '0xde23df5d': 'OnlyOrchestrator',
  '0xe57b6304': 'KeyDoesNotExist',
  '0xe798001d': 'InvalidPreCallEOA',
  '0xe6972512': 'InvalidSettlementSignature',
  '0xea6f9d87': 'RefundInvalid',
  '0xee3af24f': 'InvalidFunderSignature',
  '0xee3b3d4b': 'OrderAlreadyFilled',
  '0xf2fee1e1': 'SuperAdminCanSpendAnything',
  '0xf6ff4fb7': 'NoPeer',
  '0xf78c1b53': 'UnauthorizedCall',
  '0xf525e320': 'InvalidStatus',
  '0xfb780ab2': 'InvalidEndpointId',
  '0xfbcb0b34': 'VerificationError',
} as const
